var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from 'react';
import api from '../../../api';
import DOMPurify from 'dompurify';
function camelToWords(camelcase) {
    if (!camelcase)
        return '';
    return camelcase
        .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
        .replace(/_/g, ' ')
        .trim();
}
var formatValue = function (value, inputType) {
    if (value === null || value === undefined || value === '') {
        return 'Not provided';
    }
    if (inputType === 'money' && typeof value === 'number') {
        return "$".concat(value.toLocaleString());
    }
    if (inputType === 'date' && typeof value === 'string') {
        var date = new Date(value);
        return date.toLocaleDateString();
    }
    if (inputType === 'time' && typeof value === 'string') {
        return value;
    }
    if (inputType === 'file_upload' && typeof value === 'string') {
        return value || 'No file uploaded';
    }
    if (typeof value === 'boolean') {
        return value ? 'Yes' : 'No';
    }
    if (Array.isArray(value)) {
        return value.join(', ');
    }
    return String(value);
};
var renderQuestionValue = function (question, value, sectionKey, questionKey) {
    var _a;
    if (!question)
        return null;
    if (question.inputType === 'group') {
        return (React.createElement("div", { key: "".concat(sectionKey, "-").concat(questionKey), className: "md:col-span-2 mb-4" },
            React.createElement("h4", { className: "text-lg font-semibold text-gray-800 mb-2" }, question.question),
            React.createElement("div", { className: "bg-gray-50 p-4 rounded-lg" },
                React.createElement("div", { className: "grid grid-cols-1 gap-4" }, (_a = question.questions) === null || _a === void 0 ? void 0 : _a.map(function (subQuestion) {
                    var subValue = value === null || value === void 0 ? void 0 : value[subQuestion.questionKey];
                    if (subQuestion.inputType === 'void')
                        return null;
                    return (React.createElement("div", { key: subQuestion.questionKey, className: "flex items-center justify-between space-y-1" },
                        React.createElement("span", { className: "font-medium text-gray-600 text-left text-sm", dangerouslySetInnerHTML: {
                                __html: DOMPurify.sanitize(subQuestion.question)
                            } }),
                        React.createElement("div", { className: "flex-1 border-b border-dotted border-gray-300 mx-4" }),
                        React.createElement("span", { className: "text-gray-900" }, formatValue(subValue, subQuestion.inputType))));
                })))));
    }
    return (React.createElement("div", { key: "".concat(sectionKey, "-").concat(questionKey), className: "space-y-1 py-2 border-b w-full border-gray-100" },
        React.createElement("div", { className: "flex items-center justify-between" },
            React.createElement("span", { className: "font-medium text-gray-600 text-left text-sm" }, question.question),
            React.createElement("span", { className: "text-gray-900 text-left" }, formatValue(value, question.inputType)))));
};
var renderGroupedQuestions = function (questions, sectionData, sectionKey) {
    var renderedElements = [];
    questions.forEach(function (question) {
        var _a;
        if (question.inputType === 'group') {
            if (question.repeatBy) {
                // Handle repeated groups
                var repeatValue = sectionData === null || sectionData === void 0 ? void 0 : sectionData[question.repeatBy.targetKey];
                if (typeof repeatValue === 'number' && repeatValue > 0) {
                    var _loop_1 = function (i) {
                        var groupKey = "".concat(question.questionKey, "_").concat(i);
                        var groupData = sectionData === null || sectionData === void 0 ? void 0 : sectionData[groupKey];
                        if (groupData) {
                            renderedElements.push(React.createElement("div", { key: "".concat(sectionKey, "-").concat(groupKey), className: "md:col-span-2 mb-4" },
                                React.createElement("h4", { className: "text-lg font-semibold text-gray-800 mb-2" },
                                    question.question,
                                    " ",
                                    i),
                                React.createElement("div", { className: "bg-gray-50 p-4 rounded-lg" },
                                    React.createElement("div", { className: "grid grid-cols-1 md:grid-cols-2 gap-4" }, (_a = question.questions) === null || _a === void 0 ? void 0 : _a.map(function (subQuestion) {
                                        var subValue = groupData[subQuestion.questionKey];
                                        return (React.createElement("div", { key: subQuestion.questionKey, className: "flex items-center justify-between space-y-1" },
                                            React.createElement("span", { className: "font-medium text-gray-600 text-left text-sm" }, subQuestion.question),
                                            React.createElement("div", { className: "flex-1 border-b border-dotted border-gray-300 mx-4" }),
                                            React.createElement("span", { className: "text-gray-900" }, formatValue(subValue, subQuestion.inputType))));
                                    })))));
                        }
                    };
                    for (var i = 1; i <= repeatValue; i++) {
                        _loop_1(i);
                    }
                }
            }
            else {
                // Handle regular groups
                var groupData = sectionData === null || sectionData === void 0 ? void 0 : sectionData[question.questionKey];
                if (groupData) {
                    var element = renderQuestionValue(question, groupData, sectionKey, question.questionKey);
                    if (element) {
                        renderedElements.push(element);
                    }
                }
            }
        }
        else {
            var questionValue = sectionData === null || sectionData === void 0 ? void 0 : sectionData[question.questionKey];
            if (questionValue !== undefined &&
                questionValue !== null &&
                questionValue !== '') {
                var element = renderQuestionValue(question, questionValue, sectionKey, question.questionKey);
                if (element) {
                    renderedElements.push(element);
                }
            }
        }
    });
    return renderedElements;
};
var QuoteSummary = function (_a) {
    var _b;
    var latestQuote = _a.latestQuote, onSign = _a.onSign, handleBack = _a.handleBack;
    var _c = useState(null), productQuestions = _c[0], setProductQuestions = _c[1];
    var productId = latestQuote === null || latestQuote === void 0 ? void 0 : latestQuote.ProductId;
    var prefilledData = (_b = latestQuote === null || latestQuote === void 0 ? void 0 : latestQuote.items) === null || _b === void 0 ? void 0 : _b.requiredParams;
    useEffect(function () {
        if (!productId)
            return;
        var fetchProduct = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, pqs, err_1;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.product.get(productId)];
                    case 1:
                        response = _c.sent();
                        pqs = (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.productQuestionsSet;
                        if (pqs) {
                            setProductQuestions(JSON.parse(pqs));
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _c.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        fetchProduct();
    }, [productId]);
    if (!productQuestions || !prefilledData) {
        return (React.createElement("div", { className: "p-6" },
            React.createElement("div", { className: "animate-pulse" },
                React.createElement("div", { className: "h-6 bg-gray-200 rounded mb-4" }),
                React.createElement("div", { className: "space-y-3" },
                    React.createElement("div", { className: "h-4 bg-gray-200 rounded" }),
                    React.createElement("div", { className: "h-4 bg-gray-200 rounded w-3/4" }),
                    React.createElement("div", { className: "h-4 bg-gray-200 rounded w-1/2" })))));
    }
    return (React.createElement("div", { className: "p-4 md:p-6 bg-white" },
        React.createElement("div", { className: "flex flex-col md:flex-row md:justify-between md:items-center gap-3 mb-6 md:mb-8" },
            handleBack && (React.createElement("button", { onClick: handleBack, className: "px-4 py-2 md:px-6 md:py-3 border-2 border-primary text-primary font-semibold rounded-lg transition-colors text-sm md:text-base self-start" }, "Back")),
            React.createElement("h2", { className: "text-2xl md:text-3xl font-bold text-gray-900 text-center lg:text-center w-full" }, "Quote Summary"),
            onSign && (React.createElement("button", { onClick: onSign, className: "px-4 py-2 md:px-6 md:py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg transition-colors text-sm md:text-base self-end md:self-auto" }, "Sign"))),
        React.createElement("div", { className: "space-y-8" }, Object.keys(productQuestions).map(function (sectionKey) {
            var section = productQuestions[sectionKey];
            var sectionData = prefilledData[sectionKey];
            if (!sectionData || !section.questions)
                return null;
            var renderedQuestions = renderGroupedQuestions(section.questions, sectionData, sectionKey);
            if (renderedQuestions.length === 0)
                return null;
            return (React.createElement("div", { key: sectionKey },
                React.createElement("h3", { className: "text-lg md:text-xl font-semibold text-gray-800 mb-4 text-left capitalize" }, camelToWords(sectionKey)),
                section.subTitle && (React.createElement("p", { className: "text-sm text-gray-600 mb-4" }, section.subTitle)),
                React.createElement("div", { className: "grid grid-cols-1 md:grid-cols-2 gap-4" }, renderedQuestions)));
        }))));
};
export default QuoteSummary;
